/**
 * 其他收付单的新增页面 货品配置
 * @author zjs
 * @time 2017-09-18
 */
// import utils from '@/utils'
let vm = { 
    isTriggerFunc: true, // 标识是否触发func配置的调用
     data () {
        return {
            productConfig: [{
                label: "单据日期",
                component: "LyDatePicker",
                prop: "work_time",
                width: 140,
                json: {
                    type: 'date'
                },
                default: ""
            }, {
                prop: 'customer',
                label: '客户编码',
                width: 120,
                json: {
                    width: '471px',
                    api: 'api/customer',
                    prop: 'customer_account',
                    fields: [{
                        label: '客户编码',
                        prop: 'customer_account',
                        width: 200
                    }, {
                        label: '客户名称',
                        prop: 'customer_name',
                        width: 270
                    }]
                },
                component: 'LyAutoSearch'
            }, {
                prop: 'customer',
                label: '客户名称',
                width: 160,
                json: {
                    width: '471px',
                    api: 'api/customer',
                    prop: 'customer_name',
                    fields: [{
                        label: '客户编码',
                        prop: 'customer_account',
                        width: 200
                    }, {
                        label: '客户名称',
                        prop: 'customer_name',
                        width: 270
                    }]
                },
                component: 'LyAutoSearch'
            }, {
                prop: 'product',
                label: '往来项目',
                width: 150,
                json: {
                    width: '201px',
                    api: 'api/wanglaixm', 
                    prop: 'product_name',
                    fields: [{
                        label: '往来项目',
                        prop: 'product_name',
                        width: 200
                    }]
                },
                component: 'LyAutoSearch'
            }, {
                prop: 'brand',
                label: '品牌',
                width: 90,
                component: 'LySelect',
                json: {
                    defOne: true,
                    all: false,
                    api: "api/brand",
                    bindObj: true
                },
                default: {}
            }, {
                prop: 'amount',
                label: '金额',
                width: 90,
                json: {
                    min: -Infinity
                },
                component: 'LyInputNumber'
            }, {
                prop: 'wlye',
                label: '往来余额',
                width: 70,
                json: {
                    api: 'api/wanglaiz',
                    showkey: 'amount',
                    watch:'customer',
                    watch2: 'weidu_id'
                },
                component: 'LyAutoText'
            }, {
                prop: 'customer',
                label: '实时余额',
                width: 70,
                json: {
                    prop: 'ss_amount'
                },
                component: 'text'
            }, {
                prop: 'weidu_id',
                label: '核算纬度',
                width: 100,
                component: 'LySelect',
                json: {
                    defOne: true,
                    all: false,
                    api: "api/accountingDimension",
                    watch: 'brand'
                }
            }, {
                prop: 'employee_id',
                label: '单据业务员',
                width: 120,
                component: 'LySelect',
                json: {
                    defOne: false,
                    all: false,
                    api: "api/employee"
                }
            }, {
                prop: 'zhaiyao',
                label: '备注',
                width: 800,
                component: 'ElInput'
            }, {
                type: 'function',
                func (list, next) {
                     // 如果是修改，初始的数据不用进行计算
                    if (!vm.isTriggerFunc) {
                        vm.isTriggerFunc = true
                        // 修改时 next 必须要有 by welpher 2022-1-17
                        next()
                        // return
                    }
                    vm.timer && clearTimeout(vm.timer)
                    // 延迟执行
                    vm.timer = setTimeout(() => {
                        if (!vm.productList) {
                            vm.productList = []
                        }
                        // 遍历货品数据
                        list.forEach((v, k) => {
                            let ref = true // 标识是否可以替换品牌列中的值
                            // 1、判断暂存的数组中，往来项目与现有往来项目 是否是同一个
                            if (vm.productList[k]) {
                                let obj = vm.productList[k]
                                // 2、与暂存的往来值不一样，就修改品牌的值
                                // console.log(obj + '===' + v.product.brand_id)
                                if (obj.value === v.product.brand_id) {
                                    ref = false
                                }
                            } else {                                
                                vm.productList[k] = v.product.brand_id 
                            }
                            // 3、往来项目 更新品牌的ID 
                            if (ref && v.product.brand_id) {
                                vm.productList[k] = v.brand = {
                                    value: v.product.brand_id
                                }
                                if (v.product.weidu_id) {
                                    v.brand.weidu_id = v.product.weidu_id
                                    v.weidu_id = String(v.brand.weidu_id)
                                }
                            }
                            // 填充业务员
                            if (v.customer && v.customer.employee_id) {
                                v.employee_id = v.customer.employee_id
                                delete v.customer.employee_id
                            }
                            // v.weidu_id = String(v.brand.value)
                        })
                        // 暂存当前列表
                        // vm.productList = utils.deepClone(list)
                        next()
                    }, 100)
                }
            }]
        }
    }
}

export default vm